import { ISpinnerProps, ThemeProvider, Spinner as FluentSpinner, useTheme } from "@fluentui/react";
import { useV9CustomizedV8Theme } from "../../hooks/useV9CustomizedV8Theme";

export const Spinner = (props: ISpinnerProps) => {
    const v9Theme = useV9CustomizedV8Theme();

    return (<ThemeProvider applyTo="none" theme={v9Theme}>
        <FluentSpinner {...props} />
    </ThemeProvider>)
}